import React, { FC } from 'react'

import { ProjectDetailItem } from 'src/components/molecules'

import { ProjectDetailEntity } from 'src/types'

type Props = {
  project: ProjectDetailEntity
  className?: string
}

export const ProjectLocationDetail: FC<Props> = ({ project, className }) => {
  return (
    <div className={className}>
      <div className="tw-grid tw-gap-r2">
        <ProjectDetailItem title="郵便番号" detailText={project.zipcode} />
        <ProjectDetailItem title="都道府県" detailText={project.prefecture} />
        <ProjectDetailItem title="市区町村" detailText={project.city} />
        <ProjectDetailItem title="番地・建物" detailText={project.address} />
      </div>
    </div>
  )
}
